var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SingleColumn',{attrs:{"md":"4","offset-md":"4"}},[_c('ForgotPassword')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }